import ProductEdit from '../components/Partners/PartnerEdit'; // Assuming you have this component

export default function ProductEditPage({ handleEditPartner }) {
  return (
    <>
      <h2 className="text-2xl font-semibold mb-4 text-blue-600">Edit Partner</h2>
      <ProductEdit onAdd={handleEditPartner} />
    </>
  );
}
